import Vue from "vue";
import * as dayjs from "dayjs";

Vue.filter('NumberFormat', function (value) {c
  if (!value) {
    return '0'
  }
  let intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') //将整数部分逢三一断
  return intPartFormat
})

Vue.filter('dayjs', function(dataStr, pattern = 'YYYY-MM-DD') {
  return dayjs(dataStr).format(pattern)
})

// Vue.filter('moment', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
//   return dayjs(dataStr).format(pattern)
// })

/** 字符串超长截取省略号显示 */
Vue.filter('ellipsis', function (value, vlength = 25) {
  if(!value){
    return "";
  }
  console.log('vlength: '+ vlength);
  if (value.length > vlength) {
    return value.slice(0, vlength) + '...'
  }
  return value
})

//格式化时间戳
Vue.filter('dateTimeFormat',(value)=>{
  if(!value){
    return '';
  };
  var time = new Date(+value);
  var rightTwo = (v) => {v = '0' + v;
    return v.substring(v.length - 2, v.length)
  }
  if (time == null) return;
  var year = time.getFullYear();
  var month = time.getMonth() + 1;
  var date = time.getDate();
  var hours = time.getHours();
  var minutes = time.getMinutes();
  var seconds = time.getSeconds();
  return year + '-' + rightTwo(month) + '-' + rightTwo(date) + ' ' + rightTwo(hours) + ':' + rightTwo(minutes) + ':' + rightTwo(seconds);
})

//手机号 脱敏
Vue.filter('noPassByMobile',(str)=>{
  if(null != str && str != undefined){
    str+="";
    var pat=/(\d{3})\d*(\d{4})/;
    return str.replace(pat,'$1****$2');
  } else {
    return "";
  }
})

//证件号 脱敏
Vue.filter('noPassByIdCard',(str)=>{
  if(null != str && str != undefined){
    str+="";
    var pat=/(\d{4})\d*(\d{4})/;
    return str.replace(pat,'$1****$2');
  } else {
    return "";
  }
})

//人名 脱敏
Vue.filter('noPassByName',(str)=>{
  if(null != str && str != undefined){
    str+="";
    if(str.length <= 3){
      return "*" + str.substring(1,str.length);
    } else if(str.length > 3 && str.length <= 6){
      return "**" + str.substring(2,str.length);
    } else if(str.length > 6){
      return str.substring(0,2) + "****" + str.substring(6,str.length)
    }
  } else {
    return "";
  }
})



// WEBPACK FOOTER //
// ./src/utils/filter.js